<script setup>
</script>

<template>
    <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 animate-pulse">
        <div class="rounded bg-[#D0D5DD] h-10 w-full" v-for="i in 6" :key="i">
        </div>
    </div>
</template>